import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

import Input from '../../../form/Input';
import TextArea from '../../../form/TextArea';
import Checkbox from '../../../form/Checkbox';
import Select from '../../../form/Select';

import * as SituacaoAPI from '../../../../api/situacao';

function HomologationRegistroDialog({ open, onClose, onSave, formData, itens, empresaTabelaId, isSaving }) {
    const [dados, setDados] = useState({});
    const [situacoes, setSituacoes] = useState([]);

    useEffect(() => {
        setDados({
            ativo: true,
            ...formData,
        });
    }, [formData]);

    useEffect(() => {
        const carregarSituacoes = async () => {
            try {
                const resultSituacoes = (await SituacaoAPI.situacoes?.(empresaTabelaId)) || [];
                const filtrado = (resultSituacoes || []).filter((item) => item.homologationRegistro === true);
                setSituacoes(filtrado);
            } catch (error) {
                console.error(error);
            }
        };

        if (open) carregarSituacoes();
    }, [open]);

    function handleChange(e) {
        const { name, checked, type, value } = e.target;

        setDados((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    }

    function handleOnBlur() {}
    function handleOnFocus() {}

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <>
                <DialogTitle>{dados?.uuid ? 'Editar Registro' : 'Novo Registro'}</DialogTitle>

                <DialogContent>
                    <div>
                        <Select
                            text="Item"
                            name="itemId"
                            options={itens || []}
                            value={dados.itemId || ''}
                            handleOnChange={handleChange}
                            handleOnFocus={handleOnFocus}
                            handleOnBlur={handleOnBlur}
                            isEnum={false}
                            notOptNull={false}
                        />

                        <Select
                            text="Situação"
                            name="situacaoId"
                            options={situacoes}
                            value={dados.situacaoId || ''}
                            handleOnChange={handleChange}
                            handleOnFocus={handleOnFocus}
                            handleOnBlur={handleOnBlur}
                            isEnum={false}
                            notOptNull={false}
                        />
                        <Checkbox
                            text="Concluir"
                            title="Usuário finaliza a homologação do item"
                            name="concluiRegistro"
                            value={dados.concluiRegistro}
                            checked={!!dados.concluiRegistro}
                            handleOnChange={handleChange}
                        />
                        <Checkbox
                            text="Ativo"
                            name="ativo"
                            value={dados.ativo}
                            checked={!!dados.ativo}
                            handleOnChange={handleChange}
                        />
                    </div>

                    <div>
                        <Input
                            text="Data"
                            name="data"
                            type="date"
                            inputWidth="180px"
                            value={dados.data || ''}
                            handleOnChange={handleChange}
                            handleOnFocus={handleOnFocus}
                            handleOnBlur={handleOnBlur}
                        />

                        <Input
                            text="Prazo"
                            name="prazo"
                            type="date"
                            inputWidth="180px"
                            value={dados.prazo || ''}
                            handleOnChange={handleChange}
                            handleOnFocus={handleOnFocus}
                            handleOnBlur={handleOnBlur}
                        />
                    </div>

                    <div>
                        <Input
                            text="Descrição"
                            name="descricao"
                            inputWidth="500px"
                            value={dados.descricao || ''}
                            handleOnChange={handleChange}
                            handleOnFocus={handleOnFocus}
                            handleOnBlur={handleOnBlur}
                        />
                    </div>

                    <div>
                        <TextArea
                            text="Observação"
                            name="observacao"
                            value={dados.observacao || ''}
                            handleOnChange={handleChange}
                            handleOnFocus={handleOnFocus}
                            handleOnBlur={handleOnBlur}
                            textAlign="left"
                            linhas="4"
                            colunas="100"
                        />
                    </div>
                </DialogContent>

                <DialogActions>
                    <Button onClick={onClose} color="secondary" variant="contained">
                        Cancelar
                    </Button>
                    <Button onClick={() => onSave(dados)} color="success" variant="contained" disabled={isSaving}>
                        Salvar
                    </Button>
                </DialogActions>
            </>
        </Dialog>
    );
}

export default HomologationRegistroDialog;
